var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar"},[_c('Menu'),_c('div',{staticClass:"app-main"},[_c('Main'),_c('div',{staticClass:"app-main__outer"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }